import { ReactNode } from 'react';
import { TokenIcons } from '../../assets/icons';

type SideBySideTokensProps = {
    tokens: ReactNode[];
};

const SideBySideTokens: React.FC<SideBySideTokensProps> = ({ tokens }) => {
    return (
        <div className='side-by-side-tokens'>
            {tokens.map((token, index, arr) => (
                <div key={index} className='token' style={{ zIndex: arr.length - index }}>
                    {token ?? TokenIcons.FALLBACK}
                </div>
            ))}
        </div>
    );
};

export default SideBySideTokens;
